import { getStore } from "app/store/store"
import { getDifference } from "app/tools/common"
import { getCompactFormattedNumber } from "app/tools/number"
import { CURRENCIES } from "currency/model"
import { convertValueIntoCurrency } from "currency/tools/common"
import { getEcpm } from "form/inventory/tools/common"
import { IForm, IFormDataLoader, IFormOperatorRow } from "form/model"
import { state } from "form/state"
import { formActionCreator } from "form/store/actions"
import { IOperator } from "operator/model"
import { operatorRPO } from "operator/repository"
import { getStringOperatorId } from "operator/tools/common"
import { getForm } from "./common"

export const operatorForecastLoader: IFormDataLoader = async (form: IForm, onFinish: (error?: string) => any) => {
  try {
    form.context.operator.initialForecast = await operatorRPO.getOperatorForecast(form.tempCampaignId)
    onFinish()
  } catch (error) {
    console.error(error)
    onFinish(`Operator data-loader error ${String(error)}`)
  }
}

export function refreshOperatorForecast(runId: number): void {
  const form = getForm()
  getStore().dispatch(formActionCreator.startLoadingOperatorsForecast(form.context.appContext))
  operatorRPO
    .getOperatorForecast(form.tempCampaignId)
    .then(newForecast => {
      if (runId === state.operatorRunId) {
        getStore().dispatch(formActionCreator.setOperatorsForecast(form.context.appContext, newForecast))
      } // else ignore as it is not the latest request
    })
    .catch(error => {
      console.error(error)
      if (runId === state.operatorRunId) {
        getStore().dispatch(formActionCreator.stopLoadingOperatorsForecast(form.context.appContext))
      }
    })
}

export function getOperatorRows(operators: IOperator[]): IFormOperatorRow[] {
  const {
    context: {
      operator: { initialForecast, currentForecast }
    },
    configuration: {
      budget: { currency_id }
    }
  } = getForm()
  return operators.map(o => {
    const operatorInitialForecast = initialForecast ? initialForecast[o.publisher_id] : undefined
    const operatorCurrentForecast = currentForecast[o.publisher_id]
    const impression = operatorCurrentForecast ? operatorCurrentForecast.impression : 0
    const impressionRatio = operatorCurrentForecast
      ? `${getCompactFormattedNumber(operatorCurrentForecast.impression)}/${getCompactFormattedNumber(
          operatorCurrentForecast.impressionTotal
        )}`
      : "-"
    const impressionPercent = operatorCurrentForecast ? operatorCurrentForecast.impressionPercent : -1
    const impressionDiff = getDifference(
      operatorInitialForecast ? operatorInitialForecast.impressionPercent : undefined,
      operatorCurrentForecast ? operatorCurrentForecast.impressionPercent : undefined
    )
    const screens = operatorCurrentForecast ? operatorCurrentForecast.screen : 0
    const screensRatio = operatorCurrentForecast
      ? `${getCompactFormattedNumber(operatorCurrentForecast.screen)}/${getCompactFormattedNumber(
          operatorCurrentForecast.screenTotal
        )}`
      : "-"
    const screensPercent = operatorCurrentForecast ? operatorCurrentForecast.screenPercent : -1
    const screensDiff = getDifference(
      operatorInitialForecast ? operatorInitialForecast.screenPercent : undefined,
      operatorCurrentForecast ? operatorCurrentForecast.screenPercent : undefined
    )
    const cpm = operatorCurrentForecast
      ? convertValueIntoCurrency(
          CURRENCIES.CAD,
          currency_id,
          getEcpm(operatorCurrentForecast.spendInCad, operatorCurrentForecast.impression)
        )
      : 0
    return {
      id: getStringOperatorId(o),
      publisherId: o.publisher_id,
      publisherName: o.publisher_name,
      sspId: o.ssp_id,
      cpm,
      impression,
      impressionRatio,
      impressionPercent,
      impressionDiff,
      screens,
      screensRatio,
      screensPercent,
      screensDiff
    }
  })
}
